import Link from 'next/link';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';

import { useTranslation } from '@hooks';
import { NewButton } from '@components/ui';
import { Subtitle2, Text3 } from '@components/styles/Typography';
import { CloseIcon } from '@components/icons';

const AskCookie = () => {
    const { t } = useTranslation();
    const [cookie, setCookie] = useCookies(['user_cookie']);

    const acceptCookie = () => {
        setCookie('user_cookie', 'accept_all', {
            maxAge: 10000 * 365,
        });
    };
    const declineCookie = () => {
        setCookie('user_cookie', 'decline_all', {
            maxAge: 10000 * 365,
        });
    };
    return (
        <CookieWrapper hide={cookie.user_cookie === 'accept_all'}>
            <ContentWrapper>
                <CloseButton onClick={declineCookie}>
                    <CloseIcon width="12px" height="12px" />
                </CloseButton>
                <Text3 color="bgGray10">
                    {t('cookiePolicyText')}{' '}
                    <Link href="/cookie-policy" to="/cookie-policy" passHref>
                        {t('footerCookie')}
                    </Link>
                </Text3>

            </ContentWrapper>
            <ButtonWrapper>
                <NewButton
                    size="xlarge"
                    type="primary"
                    data-testid="accept-cookies"
                    handleClick={acceptCookie}
                >
                    <Subtitle2 color="bgGray10">{t('acceptCookie')}</Subtitle2>
                </NewButton>
            </ButtonWrapper>
            <ContentWrapper>
                <Link to="/custom-cookies" href="/custom-cookies" passHref>
                    <Text3 color="bgGray10">{t('customizeCookie')}</Text3>
                </Link>
            </ContentWrapper>
        </CookieWrapper>
    );
};

const CookieWrapper = styled.div`
    display: ${({ hide }) => (!hide ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    padding: 20px;
    position: fixed;
    z-index: 999;
    left: 45px;
    right: 0;
    bottom: 45px;
    max-width: 26.04vw;

    p {
        text-align: center;
        @media (max-width: 768px) {
            max-height: 220px;
        }
    }

    @media (max-width: 768px) {
        max-width: unset;
        left: 0;
        bottom: 0;
    }
`;
const ContentWrapper = styled.div`
    a {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.bgGray10};
    }
`;
const ButtonWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    margin: 17px 0;

    @media (max-width: 768px) {
        margin-left: 0;
    }
`;
const CloseButton = styled.button`
    position: absolute;
    right: 5px;
    top: 5px;
    background-color: transparent;
    border: none;

    &:hover {
        cursor: pointer;
        opacity: 0.7;
    }
    svg {
        fill: white;
    }
`;
export default AskCookie;
